(function () {
    // 商品画像: メイン表示(左)とサムネイル(右)の切り替え
    const wrappers = document.querySelectorAll(".tabVoxWrapper");

    wrappers.forEach((wrapper) => {
        const tabs = Array.from(wrapper.querySelectorAll(".tabs button[data-image-index]"));
        const images = Array.from(wrapper.querySelectorAll(".body .vox[data-image-index]"));

        if (tabs.length === 0 || images.length === 0) return;

        // 指定indexの画像とサムネイルだけをアクティブ化
        const setActive = (index) => {
            tabs.forEach((tab, tabIndex) => {
                tab.classList.toggle("is-active", tabIndex === index);
            });

            images.forEach((image, imageIndex) => {
                image.classList.toggle("is-active", imageIndex === index);
            });
        };

        // 初期表示は1枚目
        setActive(0);

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
                const index = Number.parseInt(tab.dataset.imageIndex ?? "0", 10);
                setActive(Number.isNaN(index) ? 0 : index);
            });
        });
    });

    // カートへ追加・お気に入りに追加: 二重クリック防止（片方送信時に同じ行の両ボタンへ is-disabled）
    document.querySelectorAll("form.js-form-once-submit").forEach((form) => {
        form.addEventListener("submit", () => {
            const actionRow = form.closest("ul.btnListS01.mbS04");
            if (actionRow) {
                actionRow.querySelectorAll("button.btnS01").forEach((btn) => {
                    btn.classList.add("is-disabled");
                });
            }
        });
    });

    // 購入数の +/- ボタン制御
    const quantityEl = document.getElementById("js-quantity-value");
    const quantityInput = document.getElementById("js-cart-quantity");
    const buttons = document.querySelectorAll(".quantityControl .qtyBtn");

    if (quantityEl && buttons.length > 0) {
        // 表示値が不正な場合も 1 を下限に扱う
        const getQuantity = () => {
            const value = Number.parseInt(quantityEl.textContent, 10);
            return Number.isNaN(value) || value < 1 ? 1 : value;
        };

        const setQuantity = (value) => {
            // 最小値は1に固定
            const nextValue = String(Math.max(1, value));
            quantityEl.textContent = nextValue;
            if (quantityInput) {
                quantityInput.value = nextValue;
            }
        };

        setQuantity(getQuantity());

        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                const current = getQuantity();
                const action = button.dataset.action;
                const next = action === "decrease" ? current - 1 : current + 1;
                setQuantity(next);
            });
        });
    }
})();
